import { CardComponentProps } from "@~/types/types";
import {
  transformVariantPriceRange,
  isPriceAtLeastMinimumThreshold,
  getCreditMessage,
} from "./utils";
import { transformPricePerUnit } from "../__shared__/PriceUtils/priceUtils";
import { PricePresentation } from "../__shared__/PriceUtils/PricePresentation";
import { PricePerUnit } from "@~/types/prodcatBaseTypes";

export function Price({
  product,
  configProps,
}: Pick<CardComponentProps, "product" | "configProps">) {
  const { variantPriceRange, variants = [] } = product;
  const pricePerUnit =
    (variants[0] as { pricePerUnit?: PricePerUnit | null } | undefined)
      ?.pricePerUnit ?? undefined;

  const transformedVariantPrice = variantPriceRange
    ? transformVariantPriceRange(variantPriceRange)
    : null;

  if (!transformedVariantPrice) return null;
  if (!isPriceAtLeastMinimumThreshold(transformedVariantPrice)) return null;

  const unitPriceInfo = pricePerUnit
    ? transformPricePerUnit(pricePerUnit)
    : undefined;

  const creditMessage = getCreditMessage(transformedVariantPrice, product);

  return (
    <PricePresentation
      transformedVariantPrice={transformedVariantPrice}
      creditMessage={creditMessage}
      product={product}
      configProps={configProps}
      unitPriceInfo={unitPriceInfo}
    />
  );
}
